module.exports = __webpack_public_path__ + "static/media/hkrfid.2cb619d8.png";